import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'
import _global from './global.vue';
import 'jspdf-autotable'
import (/* webpackChunkName: "STXIHEI-normal"*/ '../assets/fonts/STXIHEI-normal.js')


export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function (clientName,clientLogoImage,chosen_city,campaignDateTimestamp,campaignDuration,tableData,CPM,MediaCost,gender,age,spend_power, interest,poi,media_type,tableDataCommercial,reference_id,createdBy,team,ifShowViewed,adjusted_CPM,poi_ba_label_selection_list,totalNearbyBusNumber,data_source,academic_degree,parental_status,employment_sector,car_ownership,house_ownership,main_category,sub_category) {
      // Create new PDF file

      let PDF = new jsPDF('', 'pt', 'a4')
      let title = 'JCDecaux Bus Media Solution_' 
      PDF.addFont('STXIHEI-normal.ttf', 'STXIHEI', 'normal');
      PDF.setFont('STXIHEI');

      var picSrc = ''
      if (_global.serverSrc == 'http://127.0.0.1:8000/api'){
        //picSrc = '/frontend/img/'
        picSrc = '/static/img/'
      }
      else{
        picSrc = '/img/'
      }
      
      
      // Add cover page
      let leftMargin = 65.205/2
      let rightMargin = leftMargin
      let a4Width = 595.28
      let a4Height = 841.89

      let BusLogo = new Image()
      let BusLogoUrl = _global.serverSrc.slice(0,-4) + picSrc+ 'logo_cn.png';
      //JcdLogo.src = require('../assets/jcd_logo.png')
      BusLogo.src = BusLogoUrl
 
      PDF.addImage(BusLogo,'png',a4Width/2-50.5,30,101,49)
      /* 
      BusLogo.src = BusLogoUrl
      console.log('BusLogoUrl',BusLogoUrl)
      BusLogo.onload = function(){
        PDF.addImage(BusLogo,'png',a4Width/2-50.5,30,101,49);
        PDF.save('test.pdf')
      }
      */

      let BamLogo = new Image()
      let BamLogoUrl = _global.serverSrc.slice(0,-4) + picSrc + 'bam_logo.png';
      //JcdLogo.src = require('../assets/jcd_logo.png')
      BamLogo.src = BamLogoUrl
      PDF.addImage(BamLogo,'png',a4Width/2-134.75,a4Height/2-57.5-30,269.5,115)


      if (clientLogoImage !=''){
      PDF.addImage(clientLogoImage,'png',274.25,595.28,46.775,35.44)
      }
      PDF.setFontSize(20);
      PDF.text(clientName,a4Width/2,680.4,'center')

      //Add Date
      let reportDate = new Date()
      let monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let reportDate_output = monthsList[reportDate.getMonth()].toString()+ ' ' +reportDate.getDate().toString()+' '+reportDate.getFullYear().toString()
      let reportDate_output_YYMMDD = reportDate.getFullYear()+'/'+(Number(reportDate.getMonth())+1).toString()+'/'+reportDate.getDate()

      PDF.setFontSize(14);
      PDF.setFontType("normal");
      PDF.text(reportDate_output_YYMMDD,a4Width/2,a4Height-30,'center')
      
      let campaignStartDate = new Date(campaignDateTimestamp);
      let campaignStartDate_YYMMDD = campaignStartDate.getFullYear()+'/'+(Number(campaignStartDate.getMonth())+1).toString()+'/'+campaignStartDate.getDate()

      //Report Info Page
      PDF.addPage()
      PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
      PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)

      PDF.setFont('STXIHEI');
      PDF.setFontSize(20);
      PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')
      PDF.setFontSize(14);
      PDF.setFont('Helvetica')
      PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')

    
      let infoTable = [
        ['方案名称 / Name of proposal: ' + clientName,'方案编号# / Proposal#: '+reference_id],
        ['计划发布日期 / Campaign Start: '+ campaignStartDate_YYMMDD ,'发布时长（月）/ Duration(month): '+campaignDuration],
        ['发布城市 / City: '+chosen_city],
        ['巴士线路数量 / No. of bus lines: '+tableData[0].value,"巴士台数 / Bus Q'ty: "+tableData[1].value],
        ['媒体形式 / Media Format: '+media_type,'媒体刊例费总价 / Total Media Cost ￥: '+ MediaCost],
        ['BU销售人员 / BU Sales: ' +team +'/'+ createdBy,'报告时间 / Report Date: '+reportDate_output_YYMMDD]
      ]

      PDF.autoTable({
        body: infoTable,
          styles: { font: "STXIHEI"} ,
          tableWidth: 'auto',
          startY: 123.575+6,
      }
      )
      
      PDF.autoTable({
        head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
        body: [
          [tableData[4].value,CPM],
        ],
          headStyles:{fontStyle:'noraml',fontSize:8},
          styles: { font: "STXIHEI",fontSize:14} ,
          tableWidth: 'auto',
          startY: 255.15+15-5,
          columnStyles: {
            1: {cellWidth:267}
          }
      }
      )

      let ifShowViewedDescendPixel = 0
      
      if (ifShowViewed){    
        PDF.autoTable({
          head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众）\nCPM (Target Audience Based) ￥']],
          body: [
            [tableData[5].value,adjusted_CPM],
          ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 255.15+80-15,
            columnStyles: {
              1: {cellWidth:267}
            }
        }
        )

        ifShowViewedDescendPixel = 35
      }else{
        ifShowViewedDescendPixel = 0
      }


      //Selected criterias table
      PDF.setFont('STXIHEI');
      PDF.setFontSize(10);
      PDF.text('受众特征 Audience Criterias: ',leftMargin+7,340+21+ifShowViewedDescendPixel)
      
      if (data_source != 2) {
        PDF.autoTable({
          body: [
            ['性别 / Gender: '+gender,'年龄 / Age: '+age],
            ['消费能力 / Spend Power: '+spend_power,"兴趣 / Interest: "+interest],
            ['目标兴趣点 / Target POI: '+poi,"途径地点 / Nearby Location: "+poi_ba_label_selection_list],
            ['经过途经地点线路总数/Pass nearby location bus number: '+totalNearbyBusNumber.toString()]
          ],
            styles: { font: "STXIHEI",fontSize:8,} ,
            tableWidth:  'auto',
            startY: 386.735-16+ifShowViewedDescendPixel,
            columnStyles: {
              1: {cellWidth:267}
            }  
        }
        )
        
        let poi_ba_character_length = poi_ba_label_selection_list.length
      
        html2Canvas(document.querySelector('#chart_impression'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)


          let startLocationChartImpression = 450
          let contentWidthChartImpression = a4Width - leftMargin - rightMargin - 140
          let contentHeightChartImpression = 141.75+35

          // Incase to poi list too long
          if (poi_ba_character_length>40){
            startLocationChartImpression = startLocationChartImpression + 20
            contentWidthChartImpression = contentWidthChartImpression * 3/4
            contentHeightChartImpression = contentHeightChartImpression * 3/4
          }

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2-contentWidthChartImpression/2, startLocationChartImpression+ifShowViewedDescendPixel,  contentWidthChartImpression, contentHeightChartImpression)

        })

        html2Canvas(document.querySelector('#chart_cpm'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)

          let startLocationChartCpm = 630
          let contentWidthChartCpm = a4Width - leftMargin - rightMargin - 140
          let contentHeightChartCpm = 141.75+35

          // Incase to poi list too long
          if (poi_ba_character_length>40){
            startLocationChartCpm = startLocationChartCpm + 10
            contentWidthChartCpm = contentWidthChartCpm * 3/4
            contentHeightChartCpm = contentHeightChartCpm * 3/4
          }

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2-contentWidthChartCpm/2, startLocationChartCpm+ifShowViewedDescendPixel, contentWidthChartCpm, contentHeightChartCpm)
        
          // Save PDF file
          // PDF.save(title+ reportDate_output_YYMMDD+'.pdf')
          // let PdfBtoa = btoa(PDF.output())
        })
      }
      else  {
        let sub_str =  (main_category=="All" || main_category=="全部")? "" : " - " + sub_category
        PDF.autoTable({
          body: [
            ['学历 / Academic Degree: '+academic_degree,'子女 / Parental Status: '+parental_status],
            [{content: '职业 / Employment Sector: '+employment_sector, colSpan: 2}],
            ["有车 / Car Ownership: "+car_ownership,"有房 / House Ownership: "+house_ownership],
            [{content: "购物类别 / Shopping Category: "+main_category + sub_str, colSpan: 2}],
            ['目标兴趣点 / Target POI: '+poi,"途径地点 / Nearby Location: "+poi_ba_label_selection_list],
            ['经过途经地点线路总数/Pass nearby location bus number: '+totalNearbyBusNumber.toString()]
          ],
            styles: { font: "STXIHEI",fontSize:8,} ,
            tableWidth:  'auto',
            startY: 386.735-16+ifShowViewedDescendPixel,
            columnStyles: {
              0: {cellWidth:267}
            }  
        }
        )

        html2Canvas(document.querySelector('#chart_impression'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)


          let startLocationChartImpression = 500
          let contentWidthChartImpression = (a4Width - leftMargin - rightMargin)/2 //- 20
          let contentHeightChartImpression = 141.75+35+40

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          //PDF.addImage(infoPageData, 'JPEG', a4Width/2-contentWidthChartImpression/2, startLocationChartImpression+ifShowViewedDescendPixel,  contentWidthChartImpression, contentHeightChartImpression)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartImpression+ifShowViewedDescendPixel,  contentWidthChartImpression, contentHeightChartImpression)

        })

        html2Canvas(document.querySelector('#chart_cpm'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)

          let startLocationChartImpression = 500
          let contentWidthChartImpression = (a4Width - leftMargin - rightMargin)/2 //- 20
          let contentHeightChartImpression = 141.75+35+40

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          //PDF.addImage(infoPageData, 'JPEG', a4Width/2-contentWidthChartCpm/2, startLocationChartCpm+ifShowViewedDescendPixel, contentWidthChartCpm, contentHeightChartCpm)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartImpression+ifShowViewedDescendPixel,  contentWidthChartImpression, contentHeightChartImpression)

          // Save PDF file
          // PDF.save(title+ reportDate_output_YYMMDD+'.pdf')
          // let PdfBtoa = btoa(PDF.output())
        })
      }



      //Bus Line Detail Page
      PDF.addPage()
      PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
      PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
      PDF.setFont('Helvetica')
      PDF.setFontSize(14);
      PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
      PDF.setFont('STXIHEI');
      PDF.setFontSize(20);
      PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')
      
      PDF.autoTable({
        body: infoTable,
          styles: { font: "STXIHEI"} ,
          //theme:'grid',
          tableWidth: 'auto',
          cellWidth:250,
          //fontSize:14,
          startY: 123.575+6,
          lineWidth: 10
      }
      )
      
      PDF.autoTable({
        head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
        body: [
          [tableData[4].value,CPM],
        ],
          headStyles:{fontStyle:'noraml',fontSize:8},
          styles: { font: "STXIHEI",fontSize: 14} ,
          tableWidth: 'auto',
          startY: 255.15+15-5,
          columnStyles: {
            1: {cellWidth:267}
          }
      }
      )

      if (ifShowViewed){    
        PDF.autoTable({
          head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众） \nCPM (Target Audience Based) ￥']],
          body: [
            [tableData[5].value,adjusted_CPM],
          ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 255.15+80-15,
            columnStyles: {
              1: {cellWidth:267}
            }
        }
        )

        ifShowViewedDescendPixel = 35

        // busline table
        let tableDataCommercialExport = new Array()
  
        tableDataCommercial.forEach((item, index) => {
          tableDataCommercialExport[index] = new Array()
          tableDataCommercialExport[index][0] = item['bus_name']
          tableDataCommercialExport[index][1] = item['rank']
          tableDataCommercialExport[index][2] = item['media_type_label']
          tableDataCommercialExport[index][3] = item['bus_quantity']
          tableDataCommercialExport[index][4] = item['duration']
          tableDataCommercialExport[index][5] = item['rate_card']
          tableDataCommercialExport[index][6] = item['price']
          tableDataCommercialExport[index][7] = item['impression_total']
          tableDataCommercialExport[index][8] = item['adjusted_impression']
          tableDataCommercialExport[index][9] = item['CPM']
          tableDataCommercialExport[index][10] = item['adjusted_CPM']
        })
        //console.log('tableDataCommercialExport',tableDataCommercialExport)
  
        PDF.autoTable({
          head:[['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n/月/台￥\nMedia Cost\n/Mth/Unit￥','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)','千次展示\n成本\nCPM￥','千次展示\n成本\n(基于目标受众)\nCPM￥\n(Target Audience \nBased)']],
          body: tableDataCommercialExport,
            headStyles:{fontStyle:'noraml',fontSize:8},
            columnStyles: {
              0: {halign:'left'},
              1: {halign:'center'},
            },
            styles: { font: "STXIHEI",halign:'right',fontSize:8} ,
            //theme:'grid',
            margin: {left:20,right:20}, 
            tableWidth: '850',
            startY: 453.6-90+ifShowViewedDescendPixel,
      }
      )
      }else{
        ifShowViewedDescendPixel = 0

        // busline table
        let tableDataCommercialExport = new Array()
  
        tableDataCommercial.forEach((item, index) => {
          tableDataCommercialExport[index] = new Array()
          tableDataCommercialExport[index][0] = item['bus_name']
          tableDataCommercialExport[index][1] = item['rank']
          tableDataCommercialExport[index][2] = item['media_type_label']
          tableDataCommercialExport[index][3] = item['bus_quantity']
          tableDataCommercialExport[index][4] = item['duration']
          tableDataCommercialExport[index][5] = item['rate_card']
          tableDataCommercialExport[index][6] = item['price']
          tableDataCommercialExport[index][7] = item['impression_total']
          tableDataCommercialExport[index][8] = item['CPM']
        })
        //console.log('tableDataCommercialExport',tableDataCommercialExport)
  
        PDF.autoTable({
          head:[['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia Format','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体刊例费\n/月/台￥\nMedia Cost\n/Mth/Unit￥','媒体刊例费\n总价￥\nTotal Media Cost ￥','广告有效\n展示次数\nViewed\nImpressions','千次展示\n成本￥\nCPM￥']],
          body: tableDataCommercialExport,
            headStyles:{fontStyle:'noraml',fontSize:9},
            columnStyles: {
              0: {halign:'left'},
              1: {halign:'center',cellWidth: 50},
              2: {cellWidth: 70,halign:'left'},
              4: {cellWidth: 55},
              5: {cellWidth: 65},
              6: {cellWidth: 65},
              7: {cellWidth: 60},
              8: {cellWidth: 50}
            },
            styles: { font: "STXIHEI",halign:'right'} ,
            //theme:'grid',
            tableWidth: '800',
            startY: 453.6-90+ifShowViewedDescendPixel,
        }
        )
      }
      
      
      //Add confidentiality agreement
      let confidentialityAgreement = new Image()
      //confidentialityAgreement.src = require('../assets/confidentiality_agreement.png')
      let confidentialityAgreementUrl = _global.serverSrc.slice(0,-4) + picSrc + 'confidentiality_agreement.png';
      confidentialityAgreement.src = confidentialityAgreementUrl
      PDF.addImage(confidentialityAgreement,'png',leftMargin,a4Height-60,a4Width-leftMargin-rightMargin,60) 
      
      //Bus Mape Page 
      html2Canvas(document.querySelector('#map'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        taintTest : false,
        allowTaint: false,
        useCORS: true,          //允许跨域

        scale: 3,
      }).then(function(canvas){
        PDF.addPage()
        PDF.setFont('STXIHEI');
        PDF.setFontSize(15);
        PDF.text('地图参考页 Map Reference: ',550,30,'',270)

        PDF.setFontSize(6);
        PDF.text('途径地点包括单个POI和商圈\nPOI是地图上单独的点位\n商圈是多个POI的集合',500,30,'',270)
        PDF.text('Nearby Location includes POI and Business Area\nPOI is the single point\nBusiness Area is the assemble of serval POIs',465,30,'',270)

        let contentWidthMap = 600
        let contentHeightMap = 500
        let mapPage = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(mapPage, 'JPEG', 40,-300,  contentWidthMap, contentHeightMap,'','',270)// rotation 270 degrees
        
        
        //Add page number 
        PDF.setFontSize(10);
        let totalPage = PDF.internal.getNumberOfPages()
        for (let currentPage=1;currentPage<=totalPage-1;currentPage++){
          PDF.setPage(currentPage+1) // avoid cover page
          PDF.text(currentPage+'/'+Number(totalPage-1),a4Width-rightMargin,a4Height-60)
        }
        
        PDF.save(title+ reportDate_output_YYMMDD+'.pdf')
      })
    }
  }
}
//reference:https://blog.csdn.net/pratise/article/details/79249943
//https://juejin.im/post/5b73d7a6518825610072b42b